module.exports = __webpack_public_path__ + "static/media/assignLogo.c23da170.svg";